import { CreateScheduledEventModal } from '@/ui/components/createScheduledEventModal/CreateScheduledEventModal';
import { isNotNullish } from '@payaca/utilities/guards';
import { roundDateTimeUpToHalfHour } from '@payaca/utilities/timeUtilities';
import moment from 'moment-timezone';
import { FC } from 'react';
import { CommitmentItem } from './CommitmentsPanel';

type EventCommitmentItem = Extract<
  CommitmentItem,
  { __typename: 'ScheduledEventCommitment' }
>;

const ArrangeEventModal: FC<{
  commitment: EventCommitmentItem;
  projectId?: number;
  customerId?: number;
  siteAddressId?: number;
  onClose: () => void;
  onSuccess: (eventId: number) => void;
}> = (props) => {
  const {
    commitment,
    projectId,
    customerId,
    siteAddressId,
    onClose,
    onSuccess,
  } = props;

  const template = commitment.template;
  const beginAt = roundDateTimeUpToHalfHour(new Date()).toDate();
  const endAt = template.duration
    ? moment(beginAt).add(template.duration).toDate()
    : moment(beginAt).add(1, 'hours').toDate();

  return (
    <CreateScheduledEventModal
      isOpen={true}
      onClose={onClose}
      initialEventData={{
        name: template.eventName ?? undefined,
        description: template.eventDescription ?? undefined,
        tagIds: template.tags.map((t) => +t.id),
        taskIds: [],
        uploadIds: template.uploads.map((u) => +u.id),
        beginAt,
        endAt,
        dealId: projectId,
        customerIds: customerId ? [customerId] : undefined,
        location: siteAddressId ? { id: siteAddressId } : undefined,
        tasksToCreate: template.tasks.map((taskTemplate) => ({
          name: taskTemplate.taskName || 'unnamed task',
          notes: taskTemplate.taskNotes ?? undefined,
          checklistItems:
            taskTemplate.__typename === 'ScheduledEventChecklistTaskTemplate'
              ? (taskTemplate.checklistItems ?? undefined)
              : undefined,
          formTemplateId:
            (taskTemplate.__typename === 'ScheduledEventFormTaskTemplate' ||
              taskTemplate.__typename ===
                'ScheduledEventLegacyFormTaskTemplate') &&
            isNotNullish(taskTemplate.formTemplate?.id)
              ? +taskTemplate.formTemplate.id
              : undefined,
          customFieldIdentifiers:
            taskTemplate.__typename === 'ScheduledEventCustomFieldsTaskTemplate'
              ? (taskTemplate.customFieldIdentifiers ?? undefined)
              : undefined,
        })),
      }}
      disableTemplateSelect={true}
      disabledFields={['dealId']}
      hiddenFields={['customerIds']}
      onSuccess={onSuccess}
    />
  );
};

export default ArrangeEventModal;
